import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function Faqs() {
  const blocks = useBlockRenderer('faqs') as Block[]

  return <BlockRenderer blocks={blocks} />
}
